document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__description').forEach(function (root) {
    if (root.dataset.formatted) return;
    root.dataset.formatted = 'true';

    var paragraphs = Array.from(root.querySelectorAll('p'));
    if (paragraphs.length === 0) return;

    paragraphs.forEach(function (p) {
      var html = p.innerHTML;
      if (!/<br\s*\/?>/i.test(html)) return;

      var lines = html.split(/(?:<br\s*\/?>\s*){2,}|<br\s*\/?>/i)
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length > 0; });

      if (lines.length < 2) return;

      var fragment = document.createDocumentFragment();
      var currentList = null;

      lines.forEach(function (line) {
        var text = line.replace(/<[^>]+>/g, '').trim();
        var isBullet = /^\*\s+/.test(text);
        var isHeading = /:-\s*$/.test(text);

        if (isBullet) {
          if (!currentList) {
            currentList = document.createElement('ul');
            currentList.className = 'product__bullets';
            fragment.appendChild(currentList);
          }
          var li = document.createElement('li');
          li.innerHTML = line.replace(/^(\s|&nbsp;)*\*\s+/, '');
          currentList.appendChild(li);
        } else {
          currentList = null;
          var lineP = document.createElement('p');
          lineP.innerHTML = line;
          if (isHeading) lineP.classList.add('product__description-heading');
          fragment.appendChild(lineP);
        }
      });

      p.replaceWith(fragment);
    });
  });
});
